import {Progress as ProgressPrimitive} from "@base-ui/react/progress";
import * as React from "react";

import {cn} from "@/lib/utils";

function Progress({
  className,
  value,
  ...props
}: {
  className?: string;
  value?: number;
} & Omit<React.ComponentProps<typeof ProgressPrimitive.Root>, "value">) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value ?? 0}
      className={cn("bg-primary/20 relative h-2 w-full overflow-hidden rounded-full", className)}
      {...props}
    >
      <ProgressPrimitive.Track className="h-full w-full">
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className="bg-primary h-full transition-all"
          style={{width: `${value ?? 0}%`}}
        />
      </ProgressPrimitive.Track>
    </ProgressPrimitive.Root>
  );
}

export {Progress};
